import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Home.css";

function Home() {
  // Define your images and captions here
  const images = [
    { src: "/images/image1.jpg", caption: "" },
    { src: "/images/image2.jpg", caption: "" },
    { src: "/images/image3.jpg", caption: "" },
    { src: "/images/image4.jpg", caption: "" },
    { src: "/images/image5.png", caption: "" },
  ];

  const [currentImage, setCurrentImage] = useState(0);
  const [latestAnnouncement, setLatestAnnouncement] = useState("");

  useEffect(() => {
    AOS.init({ duration: 1000 });

    // Fetch announcements
    fetch("http://localhost/eac_backend/fetchann.php")
      .then((response) => response.json())
      .then((data) => {
        const latest = data.Today?.[0]?.details || "No announcements available";
        setLatestAnnouncement(latest);
      })
      .catch((error) => console.error("Error fetching announcements:", error));
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prevImage) => (prevImage + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const handleDotClick = (index) => {
    setCurrentImage(index);
  };

  return (
    <div className="Home">
      {/* Rotating Announcement Section */}
      <div className="announcement-marquee">
        <marquee>{latestAnnouncement}</marquee>
      </div>

      {/* Background Image */}
      <div
        className="image-background"
        style={{
          backgroundImage: `url(${images[currentImage].src})`,
          opacity: 1,
        }}
      ></div>

      {/* Image Caption */}
      <div className="image-caption" data-aos="fade-in">
        <p>{images[currentImage].caption}</p>
      </div>

      <div data-aos="fade-up" className="home-content">
        <h1>Welcome to District Chaman</h1>
        <p>Office of the Deputy Commissioner</p>
        {/* <button className="link">Get Started</button> */}
      </div>

      {/* Navigation Dots */}
      <div className="dots-container">
        {images.map((_, index) => (
          <div
            key={index}
            className={`dot ${index === currentImage ? "active" : ""}`}
            onClick={() => handleDotClick(index)}
          ></div>
        ))}
      </div>

      {/* Additional Sections */}
      <div className="additional-sections">
        <div className="section" data-aos="fade-up">
          <div className="section-left">
            <img
              className="profile-image"
              src="/images/small-image06.png"
              alt="Profile"
            />
            <div className="name-designation">
              <h3>Habib Ahmed Bangulzai</h3>
              <p>Deputy Commissioner</p>
            </div>
          </div>
          <div className="section-right">
            <blockquote className="quote">
              <p>
                <span className="highlighted-text">DC Chaman Message</span>
                <br />
                <span className="highlighted-word">Welcome</span> to the official website of the Deputy Commissioner's Office. In today’s fast-paced world, leveraging technology is essential to ensure efficient service delivery, transparency, and public satisfaction. Our goal is to create an accessible and user-friendly platform where citizens can stay informed about the services, facilities, and initiatives we provide.

                Through this website, we aim to bridge the gap between the administration and the public, offering digital solutions to streamline processes and improve accessibility to essential services. From online complaint registration to real-time updates on public facilities and welfare programs, we are dedicated to making your interaction with the government seamless and effective.

                Your feedback and participation play a pivotal role in our continuous efforts to enhance public support and facilities. Together, let us embrace technology to build a more responsive and inclusive community.
              </p>
            </blockquote>
          </div>
        </div>

        {/* Section 2 */}
        <div className="section" data-aos="fade-up">
          <div className="section-content">
            {/* Section Title or Content */}
          </div>
          {/* Scrolling Image Carousel */}
          <div className="image-carousel2">
            {['small-image01.png', 'small-image02.png', 'small-image03.png', 'small-image04.png', 'small-image05.png', 'small-image06.png']
              .map((imageName, idx) => (
                <div className="carousel-item" key={idx}>
                  <img
                    src={`/images/${imageName}`}  // Specify the image names separately
                    alt={`Small ${idx + 1}`}
                    className="carousel-image"
                  />
                </div>
              ))}
          </div>
        </div>

        {/* District Overview */}
        <div className="district-overview-section" data-aos="fade-up">
          <div className="section-content">
            <h2>District Chaman Overview</h2>
            <p>
              Located in the southwestern region of Pakistan, District Chaman serves as a vital hub connecting Pakistan and Afghanistan through its strategic border position. Established as a district in recent years, Chaman boasts a rich historical significance, rooted in trade and cultural exchange along the historic Silk Road.

            </p>
          </div>

          {/* Images Container */}
          <div className="images-container">

            {/* Image 1 */}
            <div className="image-item">
              <div className="image-overlay">
                <img src="/images/it.jpeg" alt="Innovative Tech 1" className="image" />
                <div className="overlay-content">
                  <h3>Innovative Growth</h3>
                  <p>
                    Chaman continues to thrive as a dynamic district, fostering growth and opportunities for its residents.
                  </p>
                </div>
              </div>
            </div>

            {/* Image 2 */}
            <div className="image-item">
              <div className="image-overlay">
                <img src="/images/geo.jpg" alt="Area Development" className="image" />
                <div className="overlay-content">
                  <h3>Geographically</h3>
                  <p>
                    Geographically, Chaman is characterized by rugged terrain, a semi-arid climate, and its proximity to the Toba Kakar mountain range. The district's location facilitates vibrant trade and commerce, making it a critical gateway for cross-border economic activities.
                  </p>
                </div>
              </div>
            </div>

            {/* Image 3 */}
            <div className="image-item">
              <div className="image-overlay">
                <img src="/images/demo.jpg" alt="Technological Advancements" className="image" />
                <div className="overlay-content">
                  <h3>Demographically</h3>
                  <p>
                    Chaman is home to a diverse population, predominantly Pashtun, with a strong cultural heritage and deep-rooted traditions. Agriculture, trade, and border-related businesses form the backbone of the local economy, while the people’s hospitality and resilience reflect the district’s vibrant spirit.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>


        {/* News & Announcements Section */}
        <div className="news-announcements-section" data-aos="fade-up">
          <div className="section-content">
            <h2>News & Announcements</h2>
            <p>
              Stay updated with the latest news, press releases, and important notifications from the district administration. Click below to read more.
            </p>
          </div>

          {/* News Items Container */}
          <div className="news-items-container">

            {/* News Item 1 */}
            <div className="news-item">
              <img src="/images/news1.jpg" alt="Latest Developments" className="news-image" />
              <h3>DC For Making Polio Drive Success In Chamann</h3>
              <p>
                Deputy Commissioner (DC) Chaman Habib Ahmed Bangulzai on Friday urged the polio workers and other relevant sectors to play their role to make the anti-polio drive a success to start from Dec 16-20
              </p>
            </div>

            {/* News Item 2 */}
            <div className="news-item">
              <img src="/images/news2.jpeg" alt="Upcoming Events" className="news-image" />
              <h3>Free Passport Distribution in Chaman Achieves Target of 5,000 Beneficiaries</h3>
              <p>
                The passport department has successfully issued 5,000 free passports to the indigenous residents of Chaman as part of a government initiative launched on Friday.
              </p>
            </div>

            {/* News Item 3 */}
            <div className="news-item">
              <img src="/images/news3.jpg" alt="Press Release" className="news-image" />
              <h3>Chaman Educational Festival 2024</h3>
              <p>
                The District Administration Chaman along with Education Department took first ever initiative of organizing Educational Festival. Experts were called upon to guide and motivate the youth for better and brighter future.

              </p>
            </div>
          </div>
        </div>


        {/* Map Section */}
        <div className="section map-section" data-aos="fade-up">
          <div className="section-content">
            <h2>District Chaman Map</h2>
            <p>
              Explore the geographical layout of Chaman, a district in the province of Balochistan, Pakistan. Navigate through the map to understand the region better.
            </p>
          </div>
          <div className="map-container">
            <iframe
              title="District Chaman Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d54526.38750216814!2d66.44112345!3d30.921423!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3fbd1a15856f4311%3A0xd34ffdb22e21aadc!2sChaman%2C%20Balochistan%2C%20Pakistan!5e0!3m2!1sen!2s!4v1700000000000&zoom=12"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
